export default "__VITE_ASSET__B2skqOju__"